module.exports = __webpack_public_path__ + "static/img/continuing_pic.jpg";